import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    esperandoSolicitacao: false,
    error: false,
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'CHATBOT_DOWNLOAD_SOLICITADO':
            return { ...state, esperandoSolicitacao: true, error: false, mensagem: '' };

        case 'CHATBOT_DOWNLOAD_SUCESSO':
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: 'sucesso' };
            
        case 'CHATBOT_DOWNLOAD_ERRO':
            return { ...state, esperandoSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true };

        case 'CHATBOT_LIMPAR_MENSAGEM':
            return { ...state, error: false, mensagem: '' };

        default:
            return state;
    }
}
